export const steps = [
  {
    step: 'STEP 01',
    title: '주문하기',
    description: '쉽고, 간편하고, 빠르게 \n 무인 주문을 경험해 보세요.',
  },
  {
    step: 'STEP 02',
    title: '결제하기',
    description:
      '다양한 종류의 결제수단으로 \n 고객님의 편의를 향상시켜주세요.',
  },
  {
    step: 'STEP 03',
    title: '적립하기',
    description: '별도의 태블릿 없이, \n 키오스크로 포인트를 적립해보세요.',
  },
  {
    step: 'STEP 04',
    title: '호출하기',
    description: '카카오톡을 이용해 \n 스마트하게 호출해보세요.',
  },
  {
    step: 'STEP 05',
    title: '관리하기',
    description:
      '언제 어디서나 확인 가능한 \n 매장관리 프로그램을 이용해보세요.',
  },
];

export const cases = [
  {
    id: 1,
    type: '프랜차이즈',
    title: '가맹점 유지가 중요한 \n 프랜차이즈 성공사례는?',
  },
  {
    id: 2,
    type: '카페 디저트',
    title: '단골손님을 늘리는 \n 간편한 멤버십 적립 방법은?',
  },
  {
    id: 3,
    type: '외식업',
    title: '바쁜 시간에 매장을 \n효율적으로 활용하는 방법은?',
  },
  {
    id: 4,
    type: '무인 유통',
    title: '모바일로 매출조회부터 재고조회까지 \n 똑똑하게 관리하는 방법은?',
  },
];
